module.exports = __webpack_public_path__ + "static/media/map_mockup.dae26562.png";